import { Category } from '@/types';

export const checkForLinkedAccounts = (category: Category): boolean => {
  if (category.accounts && category.accounts.length > 0) return true;
  return category.children.some(child => checkForLinkedAccounts(child));
};